import s from "./infoBlock.module.css";
import {useAppContext} from "../../../../../../contexts";

const InfoBlock = (props) => {
    // Destructured props
    const {
        children,
        icon,
        title,
        value = undefined
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // In case we need to parse some extra html content
    let content =
        value ?
            value.replace(/\n/g, "<br />") :
            "";

    return (
        <section className={`${s.root}`}>
            <img
                src={icon}
                alt="Location icon"
            />
            <div>
                <h2 className={`${s.title} ${highContrast ? "text-[#fecc31]" : "text-sabin-red-default"}`}>
                    {title}
                </h2>
                <p
                    className={`${s.paragraph} ${highContrast ? "text-white" : "text-[#666]"}`}
                    innerHTML={content}
                >
                    {children}
                </p>
            </div>
        </section>
    )
}

export default InfoBlock;
